module.exports = __webpack_public_path__ + "static/img/order-pc-3.5d18258b.png";